import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-custom-alert',
    templateUrl: './custom-alert.component.html',
    styleUrls: ['./custom-alert.component.scss']
})
export class CustomAlertComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<CustomAlertComponent>, // Para controlar el cierre del diálogo
        @Inject(MAT_DIALOG_DATA) public data: { titulo: string, message: string } // Recibir los datos
    ) { }

    ngOnInit(): void {
        console.log('Datos recibidos en el diálogo:', this.data);
    }

    // Método para cerrar el diálogo
    onClose(): void {
        this.dialogRef.close();
    }
}